import React from "react"

import useToggleLanguage from "../hooks/useToggleLanguage"
import { LANGUAGE_DE, LANGUAGE_EN } from "../constants"

const ContentContext = React.createContext()

const ContentProvider = ({ children, content }) => {
  const browserLanguage = navigator.language.split("-")[0]
  const initialLanguage = browserLanguage === LANGUAGE_DE ? LANGUAGE_DE : LANGUAGE_EN
  const [language, toggleLanguage] = useToggleLanguage(initialLanguage)

  return (
    <ContentContext.Provider
      value={{
        ...content,
        language: { current: language, toggle: toggleLanguage },
      }}
    >
      {children}
    </ContentContext.Provider>
  )
}

export { ContentContext, ContentProvider }
